<template>
    <div class="patient-list" :class="{'App-main':$store.getters.isApp}">
        <div class="list-container" v-if="patientList.length!=0">
            <div class="list-banners"></div>
            <div class="list-item" :class="{'itemActive':activeId == item.id}" @click="selectitem(item)" v-for="(item,index) in patientList" :key="index">
                <img src="@/assets/img/patientList-picwoman.png" v-if="item.gender==2"  class="picimg">
                <img src="@/assets/img/patientList-picman.png" v-else  class="picimg">
                <div class="item-info">
                    <p class="info-name">{{item.name}} <span class="info-tag">{{relationObj[item.relationship]}}</span> </p>
                    <p class="info-gender">{{item.gender==1?$t("patient.man"):$t("patient.woman")}}  {{item.age+$t("patient.annum")}}</p>
                </div>
                <i class="activeIcon" v-if="activeId == item.id"></i>
            </div>
            <div class="add-patient flexC" >
                <van-icon name="add-o" @click="goAdd" />
                <p @click="goAdd">{{$t("patient.addPatient")}}</p>
            </div>
        </div>
        <div class="container-add">
            <p class="btn" :class="{'activeBtn':activeId}"  @click="comfirmPatient">{{$t("patient.comfirm")}}</p>
        </div>
        <div class="patient-empty" v-if="patientList.length == 0">
            <img src="@/assets/img/patient-empty-img.png" alt="">
            <p class="txt">{{$t("patient.patientempty")}}</p>
            <div class="empty-btn" @click="goAdd">
                {{$t("patient.emptybtn")}}
            </div>
        </div>
    </div>
</template>

<script>
import { patientQuery, patientDelete, patientHsitoryQuery, addPatient } from "@/api/patient";
import { imPatientGroupChatCreate } from "@/api/user";
import { relationObj } from "@/utils/staticData";
export default {
    data(){
        return{
            patientList:[],
            relationObj,
            historyPatientShow:false,
            exisitPatient:[],
            activeId:null
        }
    },
    created(){
        if(this.$route.query._GZH_HEALTHRECORD_ == 1){
            this._GZH_HEALTHRECORD_ = this.$route.query._GZH_HEALTHRECORD_;
        }
        document.title = this.$t("patient.selectPatient")
        this.getPatientQuery();
        this.getExisitData();
    },

    methods:{
        goAdd(){
            if(this.exisitPatient.length!=0){
                this.historyPatientShow = true;
            }else{
                this.$router.push({
                    path:"/patient/add"
                })
            }
        },
        async comfirmPatient(){
            if(this.activeId){
                const toast = this.$Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: this.$t("message.loadingTxt")
                });
                const resData = await this.$imapiAxio.post(
                    '/im/patientGroupChat-create',
                    {
                        patientId:this.activeId,
                        eventId:this.$route.query.eventId
                    }
                )
                toast.clear();
                if(resData.errorCode == 0){
                    this.$router.push({
                        path:"/im/chat-list",
                    })
                }else{
                    this.$toast(resData.errorMsg)
                }
            }
        },
        selectitem(item){
            this.activeId = item.id == this.activeId?null:item.id;
        },
        getExisitData(){
            patientHsitoryQuery().then(res=>{
                this.exisitPatient = res.data.data;
            })
        },
        confirmExist(row){
            addPatient({
                id:row
            }).then(res=>{
                if(res.data.errorCode == 0){
                    this.$Toast(this.$t("comonTxt.operationsuccess"))
                    this.getPatientQuery()
                    this.getExisitData();
                }else{
                    this.$Toast(this.$t("comonTxt.operationfail"))
                }
            })
        },
       
        getPatientQuery(){
            const toast = this.$Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: this.$t("message.loadingTxt")
            });
            patientQuery({}).then(res=>{
                toast.close()
                if(res.data.errorCode == 0){
                    this.patientList = res.data.data;
                }else{
                    this.$Toast(this.$t("patient.getPatientfail"))
                }
            })
        },
    }
}
</script>

<style lang="less" >
    .patient-list{
        height: 100vh;
        background: #F5F6FA;
        // height: auto;
        overflow: auto;
        display: flex;
        flex-direction: column;
        .list-container{
            flex: 1;
            overflow: auto;
            .list-banners{
                height: 4rem;
                background: url("~@/assets/img/selectPatient-banner.png") no-repeat;
                background-size: calc(100% + 1.2rem) 100%;
            }
            .list-item{
                background: #FFFFFF;
                border-radius: 0.32rem;
                margin: 0 0.6rem 0.6rem 0.6rem;
                padding: .4rem 0.6rem;
                display: flex;
                align-items: center;
                &:nth-child(2){
                    margin-top: -0.6rem;
                }
                .picimg{
                    width: 2.2rem;
                    height: 2.2rem;
                }
                .item-info{
                    margin-left: 0.6rem;
                    flex: 1;
                    .info-name{
                        font-size: 0.64rem;
                        font-family: PingFang SC;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        color: #333333;
                        .info-tag{
                            font-size: 0.44rem;
                            padding: 0.06rem 0.18rem;
                            font-family: PingFang SC;
                            font-weight: 300;
                            color: #49A7FF;
                            background: #E1EEFD;
                            margin-left: 0.3rem;
                            border-radius: 0.1rem;
                        }
                    }
                    .info-gender{
                        margin-top: 0.46rem;
                        font-size: 0.56rem;
                        font-family: PingFang SC;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }
            .itemActive{
                border: 0.06rem solid #49A7FF;
                padding: .34rem 0.54rem;
                .activeIcon{
                    width: 0.96rem;
                    height: 0.96rem;
                    background: url("~@/assets/img/patienticonAvtive.png") no-repeat;
                    background-size: 100% 100%;
                    margin: 0 0.6rem;
                }
            }
            .add-patient {
                font-size: 0.72rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: #49A7FF;
                margin: 0.3rem 0.6rem;
                justify-content: center;
                align-items: center;
                line-height: 0.8rem;
                .van-icon {
                    font-weight: 500;
                    margin-right: 0.2rem;
                }
            }
        }
        .container-add{
            flex: 0 0 auto;
            padding: 0.8rem 0;
            .btn{
                width: 13.6rem;
                height: 2rem;
                border-radius: 1rem;
                margin: 0 auto;
                font-size: 0.72rem;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFang SC;
                font-weight: 400;
                color: #C0C4CC;
                background: #DDDFE6;
            }
            .activeBtn{
                color: #FFFFFF;
                background: linear-gradient(0deg, #499FFF 0%, #49BFFF 100%);
            }
        }
        .patient-empty{
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            img{
                width: auto;
                height: 6rem;
            }
            .txt{
                font-size: 0.56rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9B9B9B;
                margin: 0.6rem auto 0.8rem auto;
            }
            .empty-btn{
                width: 12.8rem;
                margin: 0 auto;
                height: 1.6rem;
                background: linear-gradient(0deg, #499FFF 0%, #49BFFF 100%);
                border-radius: 0.8rem;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0.72rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
            }
        }
    }
    .App-main.patient-list{
        height: 100%;
    }
</style>